import auth from '@/routes/auth';
import dashboard from '@/routes/dashboard';
import home from '@/routes/home';
import books from "@/routes/books/index.js";

export default [...auth, ...home, ...dashboard, ...books];
